import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ISLAFormData } from '../models/field/sla-form-data.model';

@Pipe({
    name: 'matGenericInputLabel',
})
export class GenericInputLabelPipe implements PipeTransform {

    constructor(
        private myTranslateService: TranslateService,
    ) {
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public transform(selectData: ISLAFormData, data?: any, checkSeparator?: boolean, useOptionSeparator?: boolean): string {
        if (!selectData?.labelKeys?.length) {
            return '';
        }

        let separator: string | string[] = selectData.separator || ' ';
        if (useOptionSeparator) {
            separator = selectData.optionSeparator || separator;
        }

        let result: string = '';
        if (!(data instanceof Array) && data) {
            data = [ data ];
        }

        if (data?.length > 0) {
            for (const val of data) {
                result += this.getLabel(selectData, checkSeparator, separator, val);
                result += ', ';
            }
            result = result.length > 0 ? result.slice(0, -2) : result;
        } else {
            result = this.getLabel(selectData, checkSeparator, separator);
        }
        return result;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getLabel(selectData: ISLAFormData, checkSeparator: boolean, separator: string | string[], val?: any): string {
        let result: string = '';
        for (let i: number = 0; i < selectData.labelKeys.length; i++) {
            const currentSeparator: string = typeof separator === 'string' ? separator : separator[ i ];
            let label: string = this.myTranslateService.instant(selectData.labelKeys[ i ], selectData.params);

            if (val) {
                label = val[ selectData.labelKeys[ i ] ] ? this.myTranslateService.instant(val[ selectData.labelKeys[ i ] ]?.toString(), selectData.params) : '';
            }

            result += label;
            const valIsZero: boolean = !val ? false : (val[ selectData.labelKeys[ i ] ] || val[ selectData.labelKeys[ i ] ] === 0);
            if ((!checkSeparator || valIsZero) && currentSeparator) {
                if (!(typeof separator === 'string' && i === selectData.labelKeys.length - 1)) {
                    result += currentSeparator;
                }
            }
        }
        return result;
    }

}
